var map = {
	"./Sad_Bird.png": "7a12",
	"./Sad_Bird@2x.png": "e5fe",
	"./cancel-reason-logo.png": "9db2",
	"./communication.png": "914e",
	"./google_play_icon.png": "d297",
	"./partner.png": "c863",
	"./workshop.png": "7112"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";